import "bootstrap/js/modal";
import Swiper, {options as defaultSwiperOptions} from "./swiper";

export const initSwiper = () => {
    const options = {
        speed: 0,
        watchOverflow: true,
        pagination: {
            dynamicBullets: true,
            el: ".swiper-pagination",
            clickable: true
        },
        slidesPerView: 'auto',
        slidesPerGroup: 1,
        spaceBetween: 10,
        // using "ratio" endpoints
        breakpointBase: 'container',

    };
    if ($(".swiper-slide").length < 3) {
        options.loop = false;
        options.stopOnLastSlide = true;
    }
    const swiper = new Swiper(".swiper-summaries", {
        ...defaultSwiperOptions,
        ...options
    });

    const modal = $("#summaries_modal");
    if ($(".swiper-slide").length < 3) {
        swiper.autoplay.stop();
    } else {
        modal.on("shown.bs.modal", () => swiper.autoplay.stop());
        modal.on("hidden.bs.modal", () => swiper.autoplay.start());
    }

    $(".student-summaries__see-more").on("click", e => {
        const text = $(e.target).data("text");
        $(".student-summaries__text--large").text(text);
        $(".student-summaries__title--large").text(
            $(e.target)
                .parents(".student-summaries__card")
                .find(".student-summaries__title")
                .text()
        );
    });
};
